<template>
  <section class="content">
    <div class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
            <div class="col-12">
              <h1>{{translate('messages.social_searchers')}}</h1>
            </div>
          </div>
          <div class="row">

            <div class="col-12">
          
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">{{translate('messages.social_searchers_list')}}</h3>

                  <div class="card-tools">
                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                        <i class="fa fa-plus-square"></i>
                        {{translate('messages.add_new')}}
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-0">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{translate('messages.keyword')}}</th>
                        <th>{{translate('messages.social_networks')}}</th>
                        <th>{{translate('messages.language')}}</th>
                        <th>{{translate('messages.actions')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="social_searcher in social_searchers.data" :key="'social-searcher-'+social_searcher.id">

                        <td>{{social_searcher.keyword}}</td>
                        <td>
                          <div v-if="social_searcher.networks">
                            <span v-for="network in social_searcher.networks" :key="'network-'+network+'-'+social_searcher.id" v-tooltip:bottom="network" data-toggle="tooltip" data-placement="bottom" class="fa-lg p-3"><i :class="network | icon_class"></i></span>
                          </div>
                        </td>
                        <td>{{social_searcher.language}}</td>
                        <td>
                          
                          <a @click="editModal(social_searcher)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                              <i class="fa fa-edit blue"></i>
                          </a>
                          
                          <a @click="deleteSocialSearcher(social_searcher.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                              <i class="fa fa-trash red"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="!social_searchers.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <pagination :data="social_searchers" @pagination-change-page="getResults"></pagination>
                </div>
              </div>
              <!-- /.card -->
            </div>
          </div>
      </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_social_searcher')}}</h5>
                    <h5 class="modal-title" v-show="editmode">{{translate('messages.update_social_searcher')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateSocialSearcher() : createSocialSearcher()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{translate('messages.keyword')}}</label>
                            <input v-model="form.keyword" type="text" name="keyword"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('keyword') }">
                            <has-error :form="form" field="keyword"></has-error>
                        </div>
                        <div class="form-group">
                          <label>{{translate('messages.language')}}</label>
                          <select class="form-control" v-model="form.language" :class="{ 'is-invalid': form.errors.has('language') }">
                          <option 
                              v-for="(language,index) in languages" :key="'lang-'+index"
                              :value="index"
                              :selected="index == form.language">{{ language }}</option>
                          </select>
                          <has-error :form="form" field="language"></has-error>
                        </div>
                        <div class="form-group row">
                          <div class="col-12">
                            <label for="social_networks">{{
                              translate("messages.social_networks")
                            }}</label>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="webSwitch" value="web" v-model="selected_networks">
                              <label class="custom-control-label" for="webSwitch"><i class="fa fa-globe fa-2x"></i> Web</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="facebookSwitch" value="facebook" v-model="selected_networks">
                              <label class="custom-control-label" for="facebookSwitch"><i class="fab fa-facebook fa-2x"></i> Facebook</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="xSwitch" value="x" v-model="selected_networks">
                              <label class="custom-control-label" for="xSwitch"><i class="fab fa-x-twitter fa-2x"></i> X</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="youtubeSwitch" value="youtube" v-model="selected_networks">
                              <label class="custom-control-label" for="youtubeSwitch"><i class="fab fa-youtube fa-2x"></i> Youtube</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="instagramSwitch" value="instagram" v-model="selected_networks">
                              <label class="custom-control-label" for="instagramSwitch"><i class="fab fa-instagram fa-2x"></i> Instagram</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="redditSwitch" value="reddit" v-model="selected_networks">
                              <label class="custom-control-label" for="redditSwitch"><i class="fab fa-reddit fa-2x"></i> Reddit</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-4 py-3">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" class="custom-control-input" id="tumblrSwitch" value="tumblr" v-model="selected_networks">
                              <label class="custom-control-label" for="tumblrSwitch"><i class="fab fa-tumblr fa-2x"></i> Tumblr</label>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="is-invalid"></div>
                          <has-error :form="form" field="social_networks"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                social_searchers : {},
                form: new Form({
                  id : '',
                  keyword: '',
                  language: '',
                  networks: ''
                }),
                selected_networks: [],
                loading : true,
                languages: [],
                page : 1
            }
        },
        methods: {

          getResults(page = 1) {

              this.$Progress.start();
              this.page = page;
              axios.get('/api/socialSearcher?page=' + page).then(({ data }) => {
                this.social_searchers = data.data
                this.loading = false;
                this.$Progress.finish();
                if(!this.social_searchers.data.length && this.page > 1){
                  this.getResults(this.page - 1);
                }
              });
          },
          editModal(social_searcher){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(social_searcher);
              this.selected_networks = social_searcher.networks;
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
              this.selected_networks = ['web','facebook','x','youtube','tumblr','reddit','instagram'];  
          },
          createSocialSearcher(){
              this.$Progress.start();
              this.form.update({networks: JSON.stringify(this.selected_networks), _method:'post'});
              this.form.post('/api/socialSearcher')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                      icon: 'success',
                      title: response.data.message
                  });
                this.$Progress.finish();
                this.getResults();
              })
              .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              })
          },
          updateSocialSearcher(){
              this.$Progress.start();
              this.form.update({networks: JSON.stringify(this.selected_networks), _method:'put'});
              this.form.post('/api/socialSearcher/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                  this.getResults(this.page);
              })
              .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              });

          },
          deleteSocialSearcher(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/socialSearcher/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.getResults(this.page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
              })
          },
          loadLanguages(){
            axios.get("/api/socialSearcher/languages").then(({ data }) => {this.languages = data.data;});
          },

        },
        mounted() {
  
        },
        created() {
          this.getResults();
          this.loadLanguages();
        }
    }
</script>
